import { selectAccount } from "~/domains/user/api/SetAccount";
import { getSessionSelectedAccount } from "~/domains/user/sessionRuntime";
import type { SelectedAccountData } from "~/domains/user/types/SessionUserData";
import type { QuoteNotificationUrlData } from "./quoteNotificationUrl";

export function needsQuoteNotificationAccountSwitch(
  data: QuoteNotificationUrlData,
  selectedAccount: SelectedAccountData | null = getSessionSelectedAccount(),
): boolean {
  if (!data.account || !data.salesOrg) {
    return false;
  }

  return selectedAccount?.uid !== data.account || selectedAccount.salesOrg !== data.salesOrg;
}

export async function switchQuoteNotificationAccount(
  data: QuoteNotificationUrlData,
  destination: string,
  navigate: (url: string) => void = (url) => window.location.assign(url),
): Promise<void> {
  if (!data.account || !data.salesOrg) {
    return;
  }

  await selectAccount({
    accountId: data.account,
    salesOrg: data.salesOrg,
  });
  navigate(destination);
}
